import { Grid, Stack } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;

const AssetInfo = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [rowData, setRowData] = useState([
    {
      asset: "Laptop",
      assetDetails: "Asus i7",
      recDate: "01/03/2020",
      assetValue: "7,500.00",
      returnedOn: null,
      remarks: null,
    },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "asset",
      headerName: "Asset",
      filter: "agNumberColumnFilter",
    },
    {
      field: "assetDetails",
      headerName: "Asset Details",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "recDate",
      headerName: "Rec.Date",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "assetValue",
      headerName: "Asset Value",
    },
    {
      field: "returnedOn",
      headerName: "Returned On",
    },
    {
      field: "remarks",
      headerName: "Remarks",
    },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      let expenseClaimList = list.data._embedded.expenses;
      // console.log(expenseClaimList);
      // setRowData(expenseClaimList);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },

      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onDelete(event);
        },
      },
    ];
    return result;
  };
  return (
    <AgGridTable
      columnDefs={columnDefs}
      onGridReady={onGridReady}
      gridRef={gridRef}
      rowData={rowData}
      getContextMenuItems={getContextMenuItems}
      editable={false}
      pagination={false}
      hideCheckbox={true}
      onSelectionChanged={onSelectionChanged}
      onRowDoubleClicked={onRowDoubleClicked}
    />
  );
};

export default AssetInfo;
